import script from "./ConfigurationHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ConfigurationHeader.vue?vue&type=script&setup=true&lang=js"

import "./ConfigurationHeader.vue?vue&type=style&index=0&id=1b6a6351&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6a6351"]])

export default __exports__